import { styled, Stack, Box } from '../../../../base';

interface StyledPyramidLevelProps {
    bgColor: string;
    widthPercent: number;
    clipInset: number;
}

export const StyledCardsRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(3),
}));

export const StyledConversionCard = styled(Stack)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 12,
    padding: theme.spacing(2, 3),
    width: '100%',
}));

export const StyledPyramidContainer = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    padding: theme.spacing(2),
}));

export const StyledPyramidLevel = styled(Stack, {
    shouldForwardProp: (prop) =>
        prop !== 'bgColor' && prop !== 'widthPercent' && prop !== 'clipInset',
})<StyledPyramidLevelProps>(({ bgColor, widthPercent, clipInset }) => ({
    width: `${widthPercent}%`,
    height: 80,
    backgroundColor: bgColor,
    clipPath: `polygon(0% 0%, 100% 0%, ${100 - clipInset}% 100%, ${clipInset}% 100%)`,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
}));
